import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { GenericService } from "../../commons/generic.service";
import { ProcessoAtivoDTO } from "../../pages/solicitacao-dilatacao/dto/processo-ativo";
import { SolicitacaoDTO } from "../../pages/solicitacao-dilatacao/dto/solicitacao";

@Injectable()
export class PadraoService extends GenericService {
  constructor(http: HttpClient) {
    super(http);
  }

  findById(id): Observable<any> {
    return this.getMethod(id);
  }

  buscarPorNumeroProcesso(
    numeroProcesso: string
  ): Observable<ProcessoAtivoDTO> {
    const param = new HttpHeaders().set("numeroProcesso", numeroProcesso);
    return this.http.get<ProcessoAtivoDTO>(this.url + "processo/", {
      headers: param,
    });
  }

  // salvarSolicitacao(solicitacao: SolicitacaoDTO): Observable<SolicitacaoDTO> {
  //   console.log(solicitacao);
  //   return this.http.post<SolicitacaoDTO>(
  //     this.url + "solicitacao/",
  //     solicitacao
  //   );
  // }

  salvarSolicitacao<T>(formData: FormData): Observable<T> {
    return this.http.post<T>(this.url + "solicitacao", formData);
  }
}
